import Main from './Main.vue'
import {default as arrematantes} from './arematantes/routes'
import {default as comitentes} from './comitentes/routes'
import {default as contatos} from './contatos/routes'
import {default as documentos} from './documentos/routes'
import {default as leiloes} from './leiloes/routes'
import {default as leiloeiro} from './leiloeiro/routes'
import {default as banners} from './banners/routes'
import {default as editar} from './utilitarios/routes'
import {default as pregao} from './pregao/routes'
import {default as pregaoComitente} from './pregao-comitente/routes'
import {default as pregaoLeiloeiro} from './pregao-leiloeiro/routes'
import {default as pregaoLeiloeiroMobile} from './pregao-leiloeiro-mobile/routes'
import {default as pregaoLeiloeiroPatio} from './pregao-leiloeiro-patio/routes'
import {default as pregaoLance} from './pregao-lance/routes'
import {default as pregaoLance2} from './pregao-lance2/routes'
import {default as pregaoLanceCronometro} from './pregao-lance-cronometro/routes'
import {default as usuarios} from './usuarios/routes'
import {default as eventos} from './eventos/routes'
import {default as popups} from './popup/routes'
import {default as apresentacaoLotes} from './apresentacao-lotes/routes'
import {default as relatoriosBasicos} from './relatorios-basicos/routes'
import {default as trabalheConosco} from './trabalhe-conosco/routes'
import {default as inadimplentes} from './inadimplentes/routes'
import {default as impedimentos} from './impedimentos/routes'
import {default as pregaoTela2} from './pregao-tela2/routes'
import {default as pregaoBotoes} from './pregao-botoes/routes'

export default [{
  path: '/website',
  name: 'website',
  component: Main,
  children: [
    ...arrematantes,
    ...comitentes,
    ...leiloes,
    ...contatos,
    ...leiloeiro,
    ...documentos,
    ...banners,
    ...editar,
    ...pregao,
    ...pregaoComitente,
    ...pregaoLeiloeiro,
    ...pregaoLeiloeiroMobile,
    ...pregaoLeiloeiroPatio,
    ...usuarios,
    ...eventos,
    ...pregaoLance,
    ...pregaoLance2,
    ...pregaoLanceCronometro,
    ...popups,
    ...apresentacaoLotes,
    ...relatoriosBasicos,
    ...trabalheConosco,
    ...inadimplentes,
    ...impedimentos,
    ...pregaoTela2,
    ...pregaoBotoes
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/routes.js